<header-tag></header-tag>
<div>
  <login *ngIf="index === -1"></login>
  <education *ngIf="index === 1"></education>
  <personal *ngIf="index === 2"></personal>
  <secondary *ngIf="index === 3"></secondary>
  <military *ngIf="index === 4"></military>
  <account *ngIf="index === 5"></account>
  <result *ngIf="index === 6"></result>
</div>


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/pworkflow.component.html